import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import './HorizontalNavBar.scss';

const HorizontalNavBarItem = ({
  path,
  label,
}) => {
  // Capture search params from current url location.
  const { search } = useLocation();

  return (
    <NavLink
      to={`${path}${search}`}
      data-testid={`horizontal-nav:${path.replace(/^\/+/, '').replace(/\/+/g, '-') || 'root'}`}
    >
      {label}
    </NavLink>
  );
};

export default HorizontalNavBarItem;
